<template>
  <template v-if="comp">
    <div :class="`${comp.properties?.columns}`">
      <template v-if="comp.typeComponent == 'TITLE'">
        <div
          :class="`${comp.properties?.class} ${comp.properties?.fontSize} ${comp.properties?.fontAling} `"
          :style="`color:${comp.properties?.fontColor}; background-color:${comp.properties?.backgroundColor}`">
          {{ comp.label }}
        </div>
      </template>
      <template v-else-if="comp.typeComponent == 'SECTION' || comp.typeComponent == 'CONTAINER'">
        <div class="grid grid-cols-12 gap-2 border border-gray-400 p-2">
          <div v-if="comp.label" class="text-blue-600 col-span-12 font-bold border-b ">
           {{ comp.multi? '#' + comp.item: '' }}  {{ comp.label }}
          </div>
            <div
              v-for="subcom in comp.components"
              :key="subcom.name"
              :class="`${subcom.properties?.columns}`"
            >
              <ComponentViewForm :comp="subcom"></ComponentViewForm>
            </div>
        </div>
      </template>
      <template v-else-if="comp.typeComponent === 'CHECKBOX'">
        <label class="text-gray-500 text-xs">{{ comp.label }}</label>
        <div class="flex items-center text-sm">
          <span v-if="comp.value === 'SI'" class="ml-1">Sí</span>
          <span v-else class="ml-1">No</span>
        </div>
      </template>
      <template v-else-if="comp.typeComponent === 'LIST'">
        <label class="text-gray-500 text-xs">{{ comp.label }}</label>
        <div class="text-sm">{{ comp.options?.find( e => e.val == comp.value) ? comp.options?.find( e => e.val == comp.value)?.text : ' ' }}</div>
      </template>
      <template v-else-if="comp.typeComponent === 'LIST_SEARCH'">
        <label class="text-gray-500 text-xs">{{ comp.label }}</label>
        <div class="text-sm">{{ comp.searchValue ? comp.searchValue : ' ' }}</div>
      </template>
      <template v-else>
        <label class="text-gray-500 text-xs">{{ comp.label }}</label>
        <div class="text-sm">{{ comp.value ? comp.value : ' ' }}</div>
      </template>
    </div>
  </template>
</template>
<script setup lang="ts">
import type { PropType } from 'vue'
import type { IFormComponent } from '@/modules/Administracion/interfaces'

const props = defineProps({
  comp: {
    type: Object as PropType<IFormComponent>,
    required: true
  }
})

const {
  comp
} = props
</script>
